module.exports = __webpack_public_path__ + "static/media/LinkedinInTouch.1b53a9a1.svg";